/* GreenVertus — carrousel produits commun. Idempotent : peut être inclus plusieurs fois,
   chaque [data-gvpc] n'est initialisé qu'une fois et tout est scopé à son bloc.
   L'ajout au panier est géré par le handler .apple-btn-buy de layout/theme.liquid. */
(function () {
  function init(root) {
    if (root.dataset.gvpcInit) return;
    root.dataset.gvpcInit = '1';

    root.querySelectorAll('.gvpc__pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var card = pill.closest('.gvpc__card');
        if (!card) return;
        card.querySelectorAll('.gvpc__pill').forEach(function (p) {
          p.classList.remove('is-selected');
          p.setAttribute('aria-pressed', 'false');
        });
        pill.classList.add('is-selected');
        pill.setAttribute('aria-pressed', 'true');
        var price = card.querySelector('.gvpc__price-value');
        var compare = card.querySelector('.gvpc__price-compare');
        var input = card.querySelector('input[name="id"]');
        if (price) price.textContent = pill.getAttribute('data-price');
        if (compare) compare.textContent = pill.getAttribute('data-compare') || '';
        if (input) input.value = pill.getAttribute('data-variant-id');
      });
    });

    var track = root.querySelector('.gvpc__track');
    var prev = root.querySelector('.gvpc__prev');
    var next = root.querySelector('.gvpc__next');
    if (!track || !prev || !next) return;

    function step() {
      var card = track.querySelector('.gvpc__card');
      if (!card) return 300;
      return card.offsetWidth + (parseFloat(getComputedStyle(track).columnGap) || 16);
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 5;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 100); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll() { document.querySelectorAll('[data-gvpc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
